import styled from 'styled-components'

export default styled.div`
  color: '';
`

export const Main = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 910px) {
    align-items: flex-start;
  }

`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
